<template>
     <v-container fluid>
         <v-card>
            <v-toolbar>
                <v-icon>cloud_download</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Cuotas por Plan: {{planNombre}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip> -->
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="4" >
                       <v-text-field v-model="params.montoDesde" label="Monto Desde" ></v-text-field>
                    </v-col>
                    <v-col cols="4" >
                       <v-text-field v-model="params.montoHasta" label="Monto Hasta" ></v-text-field>
                    </v-col>
                    <v-col cols="4" >
                       <v-text-field v-model="params.intervalo" label="Intervalo" ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" >
                       <v-select
                            :items="listaCuotas"
                            v-model="selectedCuotas"
                            label="Cant. Cuotas"
                            multiple
                          ></v-select>
                    </v-col>
                </v-row>

            </v-card-text>
           <v-card-actions>
               <v-btn dark  color="green" @click="hideActiveTask">
                    Cerrar&nbsp;
                    <v-icon >close</v-icon>                  
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn dark  color="green" @click="generarReporte">
                    Generar&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn>
            </v-card-actions>

         </v-card>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            loadingRespuestas: false,
            params:{},
            listaCuotas:[],
            selectedCuotas:[]
        }
    },
    async created() {
        this.loadTablaCoeficientes(this.tablaCoeficientesId);
    }, 
    props: {
        planId: {
            type: Number,
            required: true
        },
        tablaCoeficientesId: {
            type: Number,
            required: true
        },
        empresaId: {
            type: Number,
            required: true
        },
        planNombre: {
            type: String,
            required: true
        },
        show: {
            type: Boolean
        }
    },
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
    },  
    methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError","hideActiveTask","setReporteActivo"]),
    async generarReporte(){
         
        if(!this.validar()) return;

        this.loading = true;

        try {
            this.params.empresaId = this.empresaId;
            this.params.planId = this.planId;
            this.params.cuotas = this.selectedCuotas;
            
            var idTemp = await http.post('planes/reporteCuotasPorPlanTemporal', JSON.stringify( {parametros:  this.params} ) );
            Vue.$log.debug(idTemp);

            this.mostrarReporte(idTemp);
            
        } catch (error) {
            // Error        
            this.alertError(error)
        }
        
        this.loading = false
            self.loading = false
    },
    async mostrarReporte(idTemportal)
    {
        let params = [];
        params.push({
            "NombrePlan": this.planNombre, 
            "Id": idTemportal
        } );
        
        this.setReporteActivo({reporte: 'CuotasPorPlan.trdp', params: params})

        await this.hideActiveTask();

        window.open('/report-viewer');
    },
    async loadTablaCoeficientes(id) {
      
      this.loading = true;

      try {
        var result = await http.get('tablasCoeficientes/' +id );
        Vue.$log.debug(result);
        this.listaCuotas = result.coeficientes.map(x => x.cuotas);
        Vue.$log.debug(this.listaCuotas);
        
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    validar(){
        if(!this.params.montoDesde || isNaN(this.params.montoDesde))
        {
            this.alertWarning('Debe ingresar un monto desde válido.');
            return false;
        }

        if(!this.params.montoHasta || isNaN(this.params.montoHasta) )
        {
            this.alertWarning('Debe ingresar un monto hasta válido.');
            return false;
        }

        if(!this.params.intervalo || isNaN(this.params.intervalo) )
        {
            this.alertWarning('Debe ingresar un intervalo válido.');
            return false;
        }

        if(Number.parseFloat(this.params.montoDesde) > Number.parseFloat(this.params.montoHasta))
        {
            this.alertWarning('El monto desde no puede superar el monto hasta.');
            return false;
        }

        if(!this.selectedCuotas.length > 0)
        {
            this.alertWarning('Debe elegir al menos un valor de Cantidad de Cuotas.');
            return false;
        }

        return true;
    }
},
  
}
</script>